import { forwardRef, useImperativeHandle } from "react";
import { Form } from "react-bootstrap";

function LoadNote(props, ref) {

    useImperativeHandle(ref, () => ({
        getName: getName,
        getType: getType,
        getTitle: getTitle,
        hasSettings: hasSettings,
        getSettings: getSettings,
        getDefaultOptions: ({ createOrUpdate }) => ({})
    }));

    const getName = () => {
        return 'Бележка';
    }

    const getType = () => {
        return 'load_note';
    }

    const getTitle = () => {
        return 'Бележка на всеки артикул в операцията';
    }

    const hasSettings = () => false;

    const getSettings = ({ state, setConfig, createOrUpdate }) => {
        return null;
    }

    return getName();
}

export default forwardRef(LoadNote)